// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-bg {
  min-height: 100vh;
  background: #0f0f0f;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'IBM Plex Sans', sans-serif;
}

.login-box {
  background: #181818;
  border: 1px solid #2a2a2a;
  border-radius: 14px;
  padding: 36px;
  width: 380px;
  max-width: 92vw;
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 28px;
}

.login-brand-mark {
  width: 32px;
  height: 32px;
  background: #6366f1;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 15px;
  color: #fff;
}

.login-brand-name {
  font-size: 16px;
  font-weight: 600;
  color: #e8e8e8;
}

.login-title {
  font-size: 20px;
  font-weight: 600;
  color: #e8e8e8;
  margin-bottom: 6px;
}

.login-sub {
  font-size: 13px;
  color: #666;
  margin-bottom: 24px;
}

.login-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  margin-bottom: 16px;
  line-height: 1.4;
}

.login-success {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #10b981;
  padding: 10px 12px;
  border-radius: 6px;
  font-size: 13px;
  margin-bottom: 16px;
  line-height: 1.4;
}

.login-field-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 14px;
}

.login-field-header .login-label {
  margin-top: 0;
  margin-bottom: 6px;
}

.login-forgot-link {
  background: none;
  border: none;
  color: #818cf8;
  font-size: 11px;
  font-family: inherit;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}

.login-forgot-link:hover {
  color: #c7d2fe;
  text-decoration: underline;
}

.login-dev-box {
  margin-top: 14px;
  padding: 10px 12px;
  background: #111;
  border: 1px dashed #444;
  border-radius: 6px;
  font-size: 12px;
  color: #aaa;
  word-break: break-all;
}

.login-dev-box a {
  color: #818cf8;
  text-decoration: underline;
}

.login-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #666;
  margin-bottom: 6px;
  margin-top: 14px;
}

.login-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #333;
  border-radius: 6px;
  background: #0f0f0f;
  color: #e8e8e8;
  font-size: 13px;
  font-family: 'IBM Plex Sans', sans-serif;
  outline: none;
  transition: border-color 0.15s;
}

.login-input:focus { border-color: #6366f1; }

.login-password-field {
  position: relative;
}

.login-password-field .login-input {
  padding-right: 42px;
}

.login-password-toggle {
  position: absolute;
  top: 50%;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border: 0;
  background: transparent;
  color: #777;
  cursor: pointer;
  transform: translateY(-50%);
}

.login-password-toggle:hover,
.login-password-toggle:focus-visible {
  color: #e8e8e8;
}

.login-password-toggle:focus-visible {
  outline: 2px solid #6366f1;
  outline-offset: 2px;
  border-radius: 3px;
}

.login-password-toggle svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.login-btn {
  width: 100%;
  padding: 11px;
  margin-top: 20px;
  border: none;
  border-radius: 6px;
  background: #6366f1;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: 'IBM Plex Sans', sans-serif;
  cursor: pointer;
  transition: all 0.15s;
}
.login-btn:hover { background: #4f52d4; }
.login-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.login-switch {
  text-align: center;
  margin-top: 20px;
  font-size: 13px;
  color: #666;
}
.login-switch button {
  background: none;
  border: none;
  color: #6366f1;
  cursor: pointer;
  font-size: 13px;
  font-family: 'IBM Plex Sans', sans-serif;
  padding: 0;
  margin-left: 4px;
}
.login-switch button:hover { text-decoration: underline; }
`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,8BAA8B;AAChC;;AAEA,qBAAqB,qBAAqB,EAAE;;AAE5C;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;EACf,qBAAqB;AACvB;AACA,mBAAmB,mBAAmB,EAAE;AACxC,sBAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,wCAAwC;EACxC,UAAU;EACV,gBAAgB;AAClB;AACA,6BAA6B,0BAA0B,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&display=swap');\n\n.login-bg {\n  min-height: 100vh;\n  background: #0f0f0f;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'IBM Plex Sans', sans-serif;\n}\n\n.login-box {\n  background: #181818;\n  border: 1px solid #2a2a2a;\n  border-radius: 14px;\n  padding: 36px;\n  width: 380px;\n  max-width: 92vw;\n}\n\n.login-brand {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 28px;\n}\n\n.login-brand-mark {\n  width: 32px;\n  height: 32px;\n  background: #6366f1;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 15px;\n  color: #fff;\n}\n\n.login-brand-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: #e8e8e8;\n}\n\n.login-title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #e8e8e8;\n  margin-bottom: 6px;\n}\n\n.login-sub {\n  font-size: 13px;\n  color: #666;\n  margin-bottom: 24px;\n}\n\n.login-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #ef4444;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  margin-bottom: 16px;\n  line-height: 1.4;\n}\n\n.login-success {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #10b981;\n  padding: 10px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  margin-bottom: 16px;\n  line-height: 1.4;\n}\n\n.login-field-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin-top: 14px;\n}\n\n.login-field-header .login-label {\n  margin-top: 0;\n  margin-bottom: 6px;\n}\n\n.login-forgot-link {\n  background: none;\n  border: none;\n  color: #818cf8;\n  font-size: 11px;\n  font-family: inherit;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.15s;\n}\n\n.login-forgot-link:hover {\n  color: #c7d2fe;\n  text-decoration: underline;\n}\n\n.login-dev-box {\n  margin-top: 14px;\n  padding: 10px 12px;\n  background: #111;\n  border: 1px dashed #444;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #aaa;\n  word-break: break-all;\n}\n\n.login-dev-box a {\n  color: #818cf8;\n  text-decoration: underline;\n}\n\n.login-label {\n  display: block;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.07em;\n  color: #666;\n  margin-bottom: 6px;\n  margin-top: 14px;\n}\n\n.login-input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #333;\n  border-radius: 6px;\n  background: #0f0f0f;\n  color: #e8e8e8;\n  font-size: 13px;\n  font-family: 'IBM Plex Sans', sans-serif;\n  outline: none;\n  transition: border-color 0.15s;\n}\n\n.login-input:focus { border-color: #6366f1; }\n\n.login-password-field {\n  position: relative;\n}\n\n.login-password-field .login-input {\n  padding-right: 42px;\n}\n\n.login-password-toggle {\n  position: absolute;\n  top: 50%;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border: 0;\n  background: transparent;\n  color: #777;\n  cursor: pointer;\n  transform: translateY(-50%);\n}\n\n.login-password-toggle:hover,\n.login-password-toggle:focus-visible {\n  color: #e8e8e8;\n}\n\n.login-password-toggle:focus-visible {\n  outline: 2px solid #6366f1;\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n.login-password-toggle svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.7;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.login-btn {\n  width: 100%;\n  padding: 11px;\n  margin-top: 20px;\n  border: none;\n  border-radius: 6px;\n  background: #6366f1;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: 'IBM Plex Sans', sans-serif;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n.login-btn:hover { background: #4f52d4; }\n.login-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.login-switch {\n  text-align: center;\n  margin-top: 20px;\n  font-size: 13px;\n  color: #666;\n}\n.login-switch button {\n  background: none;\n  border: none;\n  color: #6366f1;\n  cursor: pointer;\n  font-size: 13px;\n  font-family: 'IBM Plex Sans', sans-serif;\n  padding: 0;\n  margin-left: 4px;\n}\n.login-switch button:hover { text-decoration: underline; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
